import { Button, Cascader, Collapse, notification } from "antd";
import { cloneDeep, filter, find, forEach, head, isEmpty, map, noop, isNull } from "lodash";
import { useEffect, useState } from "react";
import "./reviewReasons.scss";
import CareCoordinationService from "@services/care-coordination";
import classNames from "classnames";
import { RightOutlined } from "@ant-design/icons";
import { useCareCoordinationStore } from "@stores/useCareCoordinationStore";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import { COMPLETE } from "../../constants";

import { jsPDF } from "jspdf";
import membersService from "@services/members.service";
import { PdfProvider } from "@pages/member-details/overview/pdf";
import UtilizationReport, { PdfOpenButon, UtilizationReportProvider } from "@pages/member-details/overview/utilizationReviewReport/utilizationReport";
import Spin from "antd/es/spin";
import useSession from "@utils/useSession";
import moment, { Moment } from "moment";
import { useGlobalInformationStore } from "@stores/global_informationStore";

const { Panel } = Collapse;

const ReviewReasons = (props: any) => {
  const [assigneeList, setAssigneeList] = useState<any[]>([]);
  const driversList = useCareCoordinationStore((state) => state.driversList);
  const setDriversList = useCareCoordinationStore((state) => state.setDriversList);

  const [updatedAssigneesList, setUpdatedAssigneesList] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isReminderVisible, setIsReminderVisible] = useState<boolean>(false);
  const [dataUri, setDataUri] = useState<any>(null);

  const currentMember = membersService?.getCurrentMember || {};

  const session = useSession();
  const setProgramsData = useCareCoordinationStore((state) => state.setDataForCareCoordination);
  const activeProgram = cloneDeep(useCareCoordinationStore((state) => state.dataForCareCoordination));

  // update store for previous program state
  const setPreviousDataForCareCoordination = useCareCoordinationStore((state) => state.setPreviousDataForCareCoordination);

  const interventionStartDate = useCareCoordinationStore((state) => state.interventionStartDate);
  const activeIntervention = find(activeProgram?.interventions, { id: props?.interventionId });

  useEffect(() => {
    setIsLoading(true);
    CareCoordinationService.fetchAssigneeList().subscribe({
      next: (v) => {
        const response = v?.data?.data;
        const newResponse = map(response, (res) => {
          return {
            label: res.categoryLabel,
            value: res.categoryValue,
            abbr: res.categoryAbbr,
            children: map(res.children, (child) => {
              return {
                label: child.assigneeLabel,
                value: child.assigneeValue,
                email: child.assigneeEmail,
                // email: "tania.sharma@tredence.com",
              };
            }),
          };
        });
        setAssigneeList(newResponse);
        setIsLoading(false);
      },
      error: (e) => {
        console.log(e);
        setIsLoading(false);
      },
    });
  }, []);

  useEffect(() => {
    setIsLoading(true);
    CareCoordinationService.fetchDriversList({ patientId: props?.patientId, patientProgramId: props.patientProgramId, programId: props.programId }).subscribe({
      next: (v) => {
        let _response = v?.data?.data;

        // add isEdited Flag to show the clear icon or not( need to show only when edited)
        const response = map(_response, (item) => {
          return {
            ...item,
            isEdited: false,
          };
        });
        setDriversList(response);

        const nonEmptyDrivers = filter(response, (item) => !isNull(item.assigneeValue));
        !isEmpty(nonEmptyDrivers) ? setIsReminderVisible(true) : noop();
        setIsLoading(false);
      },
      error: (e) => {
        console.log(e);
        setIsLoading(false);
      },
    });
  }, [props?.patientId, props.patientProgramId, props.programId, setDriversList]);

  const pdfPassword = useGlobalInformationStore(state => state.secrets?.reactAppPdfPassword)

  const updateAssignee = () => {
    setIsLoading(true);

    // if the pdf is already there then do not call the Prepare PDF function
    if (dataUri) {
      callApi();
    } else {
      getPdf(pdfPassword).then((pdf: jsPDF) => {
        const _dataUri = pdf.output("datauristring");
        setDataUri(_dataUri);
        callApi(_dataUri);
      });
    }
  };

  // updating the assignee in the DB and Sending the email to the Assignee
  const callApi = (pdf = dataUri) => {
    CareCoordinationService.updateAssignee({
      patientId: props.patientId,
      payload: updatedAssigneesList,
      notificationPayload: { patientName: currentMember?.patient_name, pdf: pdf, careManagerName: `${session?.user?.lastName}, ${session?.user?.firstName}` },
    }).subscribe({
      next: (v) => {
        notification.success({
          message: "Success",
          description: "Assignees Updated Successfully.",
        });

        const _driversList = cloneDeep(driversList);
        forEach(updatedAssigneesList, (item) => {
          const driver = find(_driversList, { reviewReasonValue: item.reviewReasonValue });
          const category = find(assigneeList, { value: item.newCategoryValue });
          const assignee = find(category?.children, { value: item.newAssigneeValue });
          driver.categoryValue = item.newCategoryValue;
          driver.categoryLabel = category.categoryValue;
          driver.categoryAbbr = category.categoryAbbr;
          driver.assigneeValue = item.newAssigneeValue;
          driver.assigneeLabel = assignee.label;
          driver.assigneeEmail = assignee.email;

          const _taskIds = filter(props?.tasks, { name: driver?.reviewReasonLabel });

          let newTaskCreateDate: Moment | undefined = moment.utc();

          var d1 = newTaskCreateDate;
          var d2 = moment.utc(interventionStartDate);

          if (d1 < d2) {
            newTaskCreateDate = interventionStartDate;
          }
          Promise.all(
            map(_taskIds, async (item) => {
              const taskId = item?.id;

              return {
                call: await CareCoordinationService.updateTask({
                  patientId: props.patientId,
                  programId: props.programId,
                  interventionId: props?.interventionId,
                  taskId: taskId,
                  taskCreateDate: newTaskCreateDate,
                }),
                value: find(activeIntervention?.tasks, { id: taskId }),
              };
            })
          ).then((result) => {
            map(result, (item) => {
              if (moment(item.value.taskCreateDate).format("MM DD YY") !== moment(newTaskCreateDate).format("MM DD YY")) {
                item.call.subscribe({
                  next: (v) => {
                    item.value.taskCreateDate = newTaskCreateDate;
                  },
                  error: (e) => {
                    console.log(e);
                  },
                });
              }
            });
            setProgramsData(activeProgram);
            setPreviousDataForCareCoordination(activeProgram);
          });
        });

        // resetting the isEdited to false, since all the values are now abdated in the DB
        const newDriversList = map(_driversList, (item) => {
          return {
            ...item,
            isEdited: false,
          };
        });
        setDriversList(newDriversList);
        setIsLoading(false);
        setUpdatedAssigneesList([]);
        setIsReminderVisible(true);
      },
      error: (e) => {
        console.log(e);
        setIsLoading(false);
      },
    });
  };

  // sending the reminders
  const sendReminder = () => {
    setIsLoading(true);

    const _obj = filter(driversList, (item) => {
      return !isNull(item.assigneeValue);
    });

    const _driversList = map(_obj, (item) => {
      const category = find(assigneeList, { value: item.categoryValue });
      const assignee = find(category?.children, { value: item.assigneeValue });
      return {
        reviewReasonValue: item.reviewReasonValue,
        reviewReasonLabel: item.reviewReasonLabel,
        categoryValue: item.categoryValue,
        assigneeValue: item.assigneeValue,
        yearMonth: item.yearMonth,
        email: assignee.email,
        assigneeLabel: item.assigneeLabel, // it is new Assignee Label
      };
    });

    // getPdf().then((pdf: jsPDF) => {
    // const dataUri = pdf.output("datauristring");

    CareCoordinationService.sendReminder({
      patientId: props.patientId,
      payload: _driversList,
      notificationPayload: { patientName: currentMember?.patient_name, careManagerName: `${session?.user?.lastName}, ${session?.user?.firstName}` },
    }).subscribe({
      next: (v) => {
        notification.success({
          message: "Success",
          description: "Reminder Sent Successfully.",
        });

        setIsLoading(false);
      },
      error: (e) => {
        console.log(e);
        setIsLoading(false);
      },
    });
    // });
  };

  return (
    <Spin spinning={isLoading} indicator={<HealthemSpinner size={70} />}>
      <div className="ui-review-reasons">
        <Collapse
          defaultActiveKey={["1"]}
          expandIconPosition={"end"}
          expandIcon={({ isActive }) => {
            return (
              <div className="ui-review-reasons__collapse">
                <div className="ui-review-reasons__collapse__text">{isActive ? "Collapse" : "Expand"}</div>
                <div className="ui-review-reasons__collapse__icon">
                  <RightOutlined style={{ fontSize: "10px" }} rotate={isActive ? 90 : 0} />
                </div>
              </div>
            );
          }}
          ghost
        >
          <Panel header="Care Team Referrals" key="1" className="ui-review-reasons__heading">
            <div className="ui-review-reasons__body">
              {map(driversList?.length % 3 === 0 ? driversList : [...driversList, {}], (driver, index) => {
                return (
                  <Card
                    key={`reviewReason_${props.patientProgramId}_${index}`}
                    patientProgramId={props.patientProgramId}
                    assigneeList={assigneeList}
                    driver={driver}
                    isDisabled={activeIntervention?.status === COMPLETE}
                    handleOnChange={(obj: any) => {
                      if (obj.newAssigneeValue === undefined) {
                        // if the user as pressed the clear button then we need to set the review Reason assignee to previous Assignee
                        const _driversList = cloneDeep(driversList);
                        _driversList[index] = {
                          ..._driversList[index],
                          isEdited: false,
                        };

                        setDriversList(_driversList);
                      } else {
                        // else, setting the isEdited to True if the review reason is edited to show the clear button
                        const _driversList = cloneDeep(driversList);
                        _driversList[index] = {
                          ..._driversList[index],
                          isEdited: true,
                        };

                        setDriversList(_driversList);
                      }

                      // updating the list of the updated Review Reasons
                      let _updatedAssigneesList = updatedAssigneesList;
                      removeByAttr(_updatedAssigneesList, "reviewReasonValue", obj?.reviewReasonValue);

                      // add the updated Review reasons list only if newAssignee is not undefined
                      if (obj.newAssigneeValue === undefined) {
                        return;
                      } else {
                        setUpdatedAssigneesList([..._updatedAssigneesList, { ...obj, programId: props.programId, patientProgramId: props.patientProgramId }]);
                      }
                    }}
                  />
                );
              })}
            </div>
            <div className="ui-review-reasons__footer">
              {isReminderVisible && (
                <Button className="ui-review-reasons__footer__reminder" size="large" type="primary" onClick={sendReminder} disabled={activeIntervention?.status === COMPLETE}>
                  Send Reminder
                </Button>
              )}
              <Button size="large" type="primary" onClick={updateAssignee} disabled={isEmpty(updatedAssigneesList) || activeIntervention?.status === COMPLETE}>
                Update & Notify Assignees
              </Button>

              <PdfProvider>
                <UtilizationReportProvider>
                  <div style={{ visibility: "hidden", position: "absolute" }} className="pdfReviewReasons">
                    <PdfOpenButon title="Update & Notify Assignees" reviewReason={true} />
                    <UtilizationReport patientId={props.data?.memberPersonalInfo?.patientId} />
                  </div>
                </UtilizationReportProvider>
              </PdfProvider>
            </div>
          </Panel>
        </Collapse>
      </div>
    </Spin>
  );
};

const Card = (props: any) => {
  const _val = props?.driver?.assigneeValue !== null ? [props?.driver?.categoryValue, props?.driver?.assigneeValue] : [];
  const [value, setvalue] = useState(_val);

  useEffect(() => {
    if (props?.driver.isEdited === false) {
      setvalue(props?.driver?.assigneeValue !== null ? [props?.driver?.categoryValue, props?.driver?.assigneeValue] : []);
    }
  }, [props?.driver.isEdited, props?.driver?.assigneeValue, props?.driver?.categoryValue]);

  const onChange = (value: any[], selectedOptions: any[]) => {
    const obj = {
      reviewReasonValue: props?.driver?.reviewReasonValue,
      reviewReasonLabel: props?.driver?.reviewReasonLabel,
      categoryValue: props?.driver?.categoryValue,
      assigneeValue: props?.driver?.assigneeValue,
      newCategoryValue: value?.[0],
      newAssigneeValue: value?.[1],
      email: selectedOptions?.[1]?.email,
      assigneeLabel: selectedOptions?.[1]?.label, // it is new Assignee Label
      yearMonth: props?.driver?.yearMonth,
    };
    props.handleOnChange(obj);
  };

  const filter = (inputValue: string, path: any[]) => path.some((option) => (option.label as string).toLowerCase().indexOf(inputValue.toLowerCase()) > -1);

  const cardClassName = classNames("ui-review-reasons-card", {
    "ui-review-reasons-card--empty": !isNull(props?.driver?.assigneeValue),
  });

  return (
    <div
      className={cardClassName}
      style={
        isEmpty(props.driver?.reviewReasonLabel)
          ? {
              visibility: "hidden",
            }
          : {}
      }
    >
      <div className="ui-review-reasons-card__title">{props.driver?.reviewReasonLabel}</div>
      <Cascader
        disabled={props.isDisabled}
        key={`reviewReason_${props.patientProgramId}_${props.driver?.reviewReasonLabel}_${props?.driver?.assigneeValue}`}
        className="ui-review-reasons-card__assignee"
        options={props.assigneeList}
        onChange={(value: any[], selectedOptions: any[]) => {
          setvalue(value);
          onChange(value, selectedOptions);
        }}
        placeholder="Please select"
        showSearch={{ filter }}
        // onSearch={(value) => console.log(value)}
        displayRender={(labels: string[], selectedOptions) => {
          return `[${head(selectedOptions)?.abbr}] ${labels[labels.length - 1]}`;
        }}
        defaultValue={props?.driver?.assigneeValue ? [props?.driver?.categoryValue, props?.driver?.assigneeValue] : []}
        allowClear={props?.driver?.isEdited}
        value={value}
      />
    </div>
  );
};

export default ReviewReasons;

const getPdf = (pdfPassword: any) => {
  const content = document.querySelector(".ui-utilization-review");
  const head = document.querySelector("head");

  let html = `
    <html>
      <head>
        ${head?.innerHTML}
      </head>
      <body>
        <div class="pdf-print-area" style="width: 900px; height: auto">
          ${content?.innerHTML}
        </div>
      </body>
    </html>
`;

  const password = pdfPassword;

  const pdf = new jsPDF({
    orientation: "p",
    unit: "px",
    format: [960, (content?.clientHeight || 200) + 60],
    compress: true,
    encryption: {
      ownerPassword: password,
      userPassword: password,
    },
  });

  return new Promise<jsPDF>((resolve, reject) => {
    pdf.html(html, {
      filename: "utilization-review-report.pdf",
      margin: [30, 30, 30, 30],
      html2canvas: {
        svgRendering: true,
      },
      callback: (pdf) => {
        resolve(pdf);
      },
    });
  });
};

function removeByAttr(arr: any[], attr: string, value: number) {
  var i = arr.length;
  while (i--) {
    if (arr[i] && arr[i].hasOwnProperty(attr) && arguments.length > 2 && arr[i][attr] === value) {
      arr.splice(i, 1);
    }
  }
  return arr;
}
